import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id CA1E5FB5-D8FA-4B61-9C96-988F6829C4F5
 * name signature
 * version: 3.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/signature.svg
 * tags
 * - Form 
 */
export const SignatureIcon = createSvgIcon(<><path d="M22,22H2V20H22V22M2.26,16.83L5.09,14L2.26,11.17L3.67,9.76L6.5,12.59L9.33,9.76L10.74,11.17L7.91,14L10.74,16.83L9.33,18.24L6.5,15.41L3.67,18.24L2.26,16.83Z" /></>, 'SignatureIcon');
export default SignatureIcon